import { cn } from '@/lib/utils';

interface LoadingSkeletonProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

/**
 * LoadingSkeleton — low-contrast animated placeholder used in lieu of
 * spinners for card and table rows. First-class primitive per §18. For
 * screen readers it announces as `status` / `aria-busy`.
 */
export function LoadingSkeleton({ className, ...props }: LoadingSkeletonProps) {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label="Loading"
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  );
}

/** Pre-composed card placeholder for the dashboard / agent grid. */
export function CardSkeleton() {
  return (
    <div className="rounded-lg border border-border bg-card p-4">
      <LoadingSkeleton className="h-4 w-1/3" />
      <LoadingSkeleton className="mt-2 h-3 w-2/3" />
      <LoadingSkeleton className="mt-4 h-20 w-full" />
    </div>
  );
}

/** Pre-composed stat card placeholder (dashboard top row). */
export function StatCardSkeleton() {
  return (
    <div className="rounded-lg border border-border bg-card p-4">
      <LoadingSkeleton className="h-3 w-1/2" />
      <LoadingSkeleton className="mt-3 h-7 w-1/3" />
    </div>
  );
}
